
import React from 'react';
import { formatoDecimal } from '../../utilities/formatoNumeros';
import { updateEstadoTiposPublicaciones } from '../../api/axios';
import { toast } from 'react-toastify';

export default class TipoPublicacionesListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      estado: props.estado
    };
  }

  handleSwitchChange = async (e) => {
    e.stopPropagation();
    const { codigo, filtro, onEstadoActualizado, onBuscarConEstado } = this.props;
    const nuevoEstado = this.state.estado === 0 ? 2 : 0;
    try {
      const response = await updateEstadoTiposPublicaciones({ id: codigo, estado: nuevoEstado });
      const mensaje = response?.data?.mensaje || 'Estado actualizado';
      this.setState({ estado: nuevoEstado }, () => {
        toast.success(mensaje);
        // Si hay filtro de estado, hacer fetch con ese estado
        if (filtro && typeof filtro.estado === 'number' && typeof onBuscarConEstado === 'function') {
          onBuscarConEstado(filtro.estado);
        } else if (typeof onEstadoActualizado === 'function') {
          // Si no hay estado, solo refresca el switch localmente
          onEstadoActualizado(codigo, nuevoEstado);
        }
      });
    } catch (err) {
      toast.warn('Error al actualizar el estado');
    }
  };


  render = () => {
    const { codigo, descripcion, comision, cantidadGrupoPlanes, cantidadPublicaciones } = this.props;
    const { estado } = this.state;
    const isActivo = estado === 0;
    return (
      <div className="list-group-item hover-background-color">
        <div className="row justify-content-between align-items-center">
          <div className="col-2 col-md-1" style={{cursor: 'pointer'}} onClick={this.props.onEdit}>
            <h6 className="box-title m-b-5 font-weight-bold">{codigo}</h6>
          </div>
          <div className="col-6 col-md-4 text-break" style={{cursor: 'pointer'}} onClick={this.props.onEdit}>
            <small className="font-14 applyFont">{descripcion}</small><br />
          </div>
          <div className="col-4 col-md-4 d-flex justify-content-end align-items-center">
            <small className="font-14 applyFont">
              {cantidadPublicaciones} <span className="ms-1">Publicaciones</span>
            </small>
          </div>
          <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
            <small className="font-14 applyFont">
              {cantidadGrupoPlanes} <span className="ms-1">Grupos</span>
            </small>
          </div>
          <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
            <small className="font-14 applyFont">
              {formatoDecimal(comision)}
              <i className="fas fa-percent d-inline-block mx-1" />
            </small>
          </div>
          <div className="col-2 col-md-1 d-flex justify-content-start align-items-center">
            <div className="custom-control form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                checked={isActivo}
                onChange={this.handleSwitchChange}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}